import { AppStore } from 'src/store';
import { Roles } from 'src/store/api/users.api';

export const checkPermission = (roles: Roles[]) => {
  const role = AppStore.getState().auth.user?.role;
  return role ? roles.includes(role) : false;
};
